import { getCurrentInstance } from 'vue'
export default () => {
  return getCurrentInstance()?.proxy
}
